import * as types from "./types";
import { BookingArtist } from '../../models/booking-artist.model';
import { updateMutatable } from "../../../../store/global/types";
import { get, last, set } from 'lodash';

import { SELECT_BOX, MINIMIZE_BOX, MAXIMIZE_BOX, PIN_BOX } from '../../../../plugins/box-widget/store.functions';
import { findCheclistItemByName } from '../../models/checklists.model';
import { defaultBookingOverview } from '../../models/booking-overview.model';
import { DataStates } from '../../../../store/global/data-state';
import { setBookingStatusColorMap } from '../../models/booking-artist.model';
import { createCalendarDateArtist } from '../../models/calendar-date-artist.model';
import { getDefaultFilter } from '../../models/filter.model';
import { appendYearsToMonthList, bookingMonthToDate } from '../../models/booking-month.model';
import { implementSetAllNavTabDetailsMutation } from '../../../../dt-plugins/sidewindow/nav-tab';

import { reject, map, contains, pipe } from 'ramda';


const BOOKING_STATUS_NAME = 'booking_status_name';


export const bookingsMutations = {
  [types.SET_BOOKING_MODULE_INFO](state, payload) {
    let {
      users,
      artists,
      statuses,
      months,
      user,
      contract_months,
      rootGetters,
    } = payload;
    console.log("INITIAL PAYLOAD::::", payload)


    // A Odd Bug Fix of Client ID bpitchcontrol
    // API was returning 2000 Years in the Months Array..\
    // TODO: Fix From the API. Temporary Fix.
    // months = months.slice(-100);

    state.users = users;

    const filterBlockedArtists = (artists) => artists.filter(e => {
      // console.log({'mutations.js:44 rootGetters' : rootGetters});
      // return true;
      // (rootGetters.account?.user_permissions?.blocked?.booking_artists || [])
      // console.log({'mutations.js:47 (rootGetters.account?.user_permissions?.blocked?.booking_artists || [])' : (rootGetters.account?.user_permissions?.blocked?.booking_artists || [])});
      return !(rootGetters.account?.user_permissions?.blocked?.booking_artists || []).includes(`${e.artist_id}`);
    })

    if (!state.artists || (state.artists && state.artists.length == 0)) {
      state.artists = filterBlockedArtists(artists);
    } else {
      // Merge The booking Module Artist Array with the Booking Artist List Array - If that exists prior
      console.log("else::::", !state.artists || (state.artists && state.artists.length == 0))
      state.artists = filterBlockedArtists(state.artists.map(e => {
        return {
          ...e,
          ...(artists.find(a => a.artist_id == e.artist_id) || {}),
        }
      }))
    }

    // Artist Not available from the previous code - Other Attributes are not available if Booking Module Request returns after artist list Request
    // state.artists = artists; 

    state.statuses = statuses;
    // console.log("Log: state.statuses", state.statuses)

    // console.log("Log: bookingMonthToDate(months[months.length - 1])", bookingMonthToDate(months[months.length - 1]))
    // console.log("Log: bookingMonthToDate(months[0])", bookingMonthToDate(months[0]))

    // state.months = months;
    // Appending 12 months To future proof Adding Calendar Dates

    // This is the Previous Logic - that appended 1 year to the Last Contracted Booking Month `lastMonth + 1 Year`
    // state.months = appendYearsToMonthList(bookingMonthToDate(months[0]), bookingMonthToDate(lastMonth), 4);

    // This is the New Logic - that appends 4 years to the current Date `currentDate + 4 Year`
    state.months = appendYearsToMonthList(bookingMonthToDate(months[0]), new Date(), 4);
    console.log({ 'mutations.js:68 state.months': state.months });

    // state.months = months;
    console.log("Log: state.months", state.months);


    state.user = user;
    state.contract_months = contract_months;

    // console.log(payload);


    const statusColorMap = statuses.reduce((accm, cur) => {
      accm[cur.booking_status_name] = `#${cur.booking_status_colour}`;
      return accm;
    }, {});
    setBookingStatusColorMap(statusColorMap);

  },

  [types.UPDATE_CALENDAR_LIST_MONTHS](state, payload) {
    state.months = payload;
  },

  [types.SET_USERS](state, payload) {
    state.users = payload;
  },

  [types.SET_SELECTED_MONTHS](state, payload) {
    state.selectedMonths = payload;
  },
  [types.SET_BOOKING_LIST](state, payload) {
    state.bookingList = payload;
  },
  [types.SET_BOOKING_DETAILS_FLAG](state, payload) {
    // state.bookingDetailsFlag = payload;
  },
  [types.SET_SELECTED_BOOKING](state, payload) {
    state.selectedBooking = payload;
  },
  // Set Booking Selected Tab
  [types.SET_BOOKING_TAB](state, payload) {
    state.bookingSideWindowSelectedTab = payload;
  },

  [types.SET_BOOKING_ARTIST_LIST](state, payload) {
    state.bookingArtistList = BookingArtist.toList(payload);
  },
  [types.SET_BOOKING_ARTIST_LIST_LOADING](state, payload) {
    state.bookingArtistListLoading = payload;
  },
  [types.SET_BOOKING_ARTIST_PAGINATION](state, payload) {
    state.paginationFilter = payload;
  },


  [types.SET_BOOKING_OVERVIEW](state, payload) {
    state.bookingOverview = {
      ...defaultBookingOverview(),
      ...payload
    };

    // console.log(payload);

    const artists = payload.artists.filter(e => e.artist_id);

    state.bookingArtistList = BookingArtist.updateList(state.bookingArtistList, artists);

    state.bookingOverviewArtists = BookingArtist.toPkList(artists);

    // console.log(state.bookingOverviewArtists, state.bookingArtistList);
  },
  [types.UPDATE_BOOKING_OVERVIEW](state, payload) {
    state.bookingOverview = {
      ...state.bookingOverview,
      ...payload
    };
  },
  [types.SET_CUSTOM_CHECKLIST](state, payload) {
    state.custom_checklist = payload;
  },
  [types.SET_BOOKING_NOTES](state, { id, value }) {
    if (state.bookingOverview.cdate.calendar_date_id === id) {
      state.bookingOverview.cdate.notes = value;
    }
  },

  [types.UPDATE_BOOKING_NOTES](state, payload) {
    state.notes = {
      ...state.notes,
      ...payload
    };

    set(state.bookingOverview, state.notes.xpath, state.notes.value);
  },

  [types.SET_CHECKLIST_ITEM_DATASTATE](state, { item, dataState }) {
    const checkListItem = findCheclistItemByName(state.checklist, item.name);
    checkListItem.dataState = dataState;
  },

  [types.SET_CHECKLIST_ITEM_VALUE](state, { item, value }) {
    set(state.bookingOverview, item.xpath, value);
  },

  [types.SET_BOOKING_OFFER_NOTES_DATASTATE](state, value) {
    state.offer_notes.dataState = value;
  },
  [types.UPDATE_BOOKING_OFFER_NOTES](state, payload) {
    state.offer_notes = {
      ...state.offer_notes,
      ...payload
    };

    set(state.bookingOverview, state.offer_notes.xpath, state.offer_notes.value);
  },

  [types.SET_BOOKING_ARTISTS_STATUS](state, { calendarDateArtistId, PRIMARY_KEY, value }) {
    const artist = state.bookingArtistList.find(e => e.PRIMARY_KEY === PRIMARY_KEY);
    artist[BOOKING_STATUS_NAME] = value;
  },

  [types.SET_BOOKING_ARTIST_OFFER_NOTE](state, { calendarDateArtistId, PRIMARY_KEY, value }) {
    const artist = state.bookingArtistList.find(e => e.PRIMARY_KEY === PRIMARY_KEY);
    artist.first_offer_notes = value;
  },

  // !IMPORTANT NOTES
  // The update operation is retried twice. If the search is undefined first time 
  // It indicates that the app might be loading the bookingArtistList the first time.
  // it's retried a second time after 1 second. 

  [types.UPDATE_BOOKING_ARTIST](state, { calendarDateArtist = createCalendarDateArtist() }) {
    // console.log(state.bookingArtistList, calendarDateArtist);
    let artist = state.bookingArtistList.find(e => e.calendar_date_artist_id === calendarDateArtist.calendar_date_artist_id);
    // console.log(artist);
    if (artist) {
      Object.keys(calendarDateArtist).map(key => {
        artist[key] = calendarDateArtist[key];
      })
    } else {
      setTimeout(() => {
        artist = state.bookingArtistList.find(e => e.calendar_date_artist_id === calendarDateArtist.calendar_date_artist_id);
        if (artist) {
          Object.keys(calendarDateArtist).map(key => {
            artist[key] = calendarDateArtist[key];
          })
        }
      }, 1000);
    }
  },

  [types.DELETE_BOOKING_ARTIST](state, { calendarDateId, artistId }) {
    // console.log(calendarDateId, artistId);
    state.bookingArtistList = reject(a => a.artist_id == artistId && a.calendar_date_id == calendarDateId, state.bookingArtistList);
  },
  [types.LOAD_BOOKING_ARTIST](state, artists) {
    // debugger;
    const artistBA = BookingArtist.dataToList(artists);

    const existingPKs = state.bookingArtistList.map(e => e.PRIMARY_KEY);


    const calendarDateId = artistBA[0].calendar_date_id;

    const existingCalendarDateArtist = BookingArtist.create(state.bookingArtistList.find(e => e.calendar_date_id === calendarDateId));

    const start_date = existingCalendarDateArtist.start_date;
    const booking_location_name = existingCalendarDateArtist.booking_location_name;
    const city = existingCalendarDateArtist.city;

    const assignMissingPropsToBookingArtist = map(element => ({
      ...element,
      start_date,
      booking_location_name,
      city
    }))

    const filterNewArtists = reject(element => contains(element.PRIMARY_KEY, existingPKs));

    // const getNewArtists = reject(element => contains(element.PRIMARY_KEY, existingPKs));

    const getNewArtists = pipe(
      filterNewArtists,
      assignMissingPropsToBookingArtist
    );

    const newArtists = getNewArtists(artistBA);

    state.bookingArtistList = [
      ...state.bookingArtistList,
      ...newArtists
    ];
    state.bookingOverviewArtists = [
      ...state.bookingOverviewArtists,
      ...newArtists.map(e => e.PRIMARY_KEY)
    ];
  },

  [types.SET_SELECTED_INVOICE_LINE](state, payload) {
    state.selectedInvoiceLines = payload;
  },

  [types.SET_INVOICE_LINES_DATASTATE](state, payload) {
    state.invoiceLines.dataState = payload;
  },
  [types.SET_INVOICE_LINES](state, payload) {
    // Reset selectedInvoiceLines after setting invoice lines

    state.selectedInvoiceLines = new Set();

    state.invoiceLines.data = payload;
    state.invoiceLines.dataState = DataStates.LOADED;
  },
  [types.UPDATE_INVOICE_LINES_PRICE](state, { invoiceLineId, price }) {
    state.invoiceLines.data = state.invoiceLines.data.map(il => {
      if (il.invoiceline_id == invoiceLineId) {
        return {
          ...il,
          price: price
        };
      } else {
        return il;
      }
    });
  },
  [types.UPDATE_INVOICE_LINES_PRICE_TEXT](state, { invoiceLineId, price, text }) {
    state.invoiceLines.data = state.invoiceLines.data.map(il => {
      if (il.invoiceline_id == invoiceLineId) {
        return {
          ...il,
          price: price,
          text: text
        };
      } else {
        return il;
      }
    });
  },
  [types.UPDATE_INVOICE_LINES](state, { invoiceLineId, name, value }) {
    state.invoiceLines.data = state.invoiceLines.data.map(il => {
      if (il.invoiceline_id == invoiceLineId) {
        return {
          ...il,
          [name]: value
        };
      } else {
        return il;
      }
    });
  },
  [types.SET_TAX_TYPES](state, payload) {
    state.taxTypes = payload;
  },
  [types.DELETE_INVOICE_LINES](state, payload) {
    state.invoiceLines.data = state.invoiceLines.data.filter(e => e.invoiceline_id !== payload);
  },

  [types.SET_INVOICE_TEXT](state, { invoiceLineId, value }) {
    state.invoiceLines.data = state.invoiceLines.data.map(e => {
      if (e.invoiceline_id === invoiceLineId) {
        e.text = value;
      }
      return e;
    });
  },



  [types.DELETE_CONTACT_RELATION](state, { contactRelationId }) {
    const contactRelations = state.travelDetailsState.data.contact_relations;
    // console.log(contactRelations.length, JSON.parse(JSON.stringify(contactRelations)));
    state.travelDetailsState.data.contact_relations = contactRelations.filter(e => e.contact_relation_id !== contactRelationId);
    // console.log(state.travelDetailsState.data.contact_relations.length);

  },

  [types.INSERT_CONTACT_RELATION](state, { contact, calendarDateId }) {
    state
      .travelDetailsState
      .data
      .contact_relations = [
        ...state
          .travelDetailsState
          .data
          .contact_relations,
        contact
      ];
  },
  [types.SET_CONTACT_RELATION](state, payload) {
    state
      .travelDetailsState
      .data
      .contact_relations = payload;
  },

  [types.TASKS.SET.ALL](state, payload) {
    state.selectedBookingTasks = payload.items;
  },


  // Send Document and Files Mutations

  [types.SET_SEND_DOCUMENT_FILES_DATA](state, payload) {
    state.sendDocumentFilesData = payload;
  },

  [types.SET_ITEM_GROUP](state, payload) {
    state.itemGroups = payload;
  },

  [types.SELECT_BOX]: SELECT_BOX,
  [types.MINIMIZE_BOX]: MINIMIZE_BOX,
  [types.MAXIMIZE_BOX]: MAXIMIZE_BOX,
  [types.PIN_BOX]: PIN_BOX,

  [types.SET_LOGGED_USER_TASKS](state, payload) {
    state.loggedUserTasks = payload;
  },

  [types.SET_BOOKING_REQUESTS](state, payload) {
    // console.log(payload);
    state.bookingRequests = payload;
  },

  [types.SET_BOOKING_TEMPLATES](state, payload) {
    state.bookingTemplates = payload;
  },
  // Filter Mutations
  [types.SET_FILTER](state, payload) {
    state.filter = {
      ...state.filter,
      ...payload
    };
  },
  [types.RESET_FILTER](state) {
    state.filter = getDefaultFilter();
  },

  // External Dates Mutations
  [types.SET_EXTERNAL_CALENDAR_DATES](state, payload) {
    state.externalDates = payload;
  },
  // EVENT DETAILS MUTATIONS
  [types.SET_EVENT_DETAILS](state, payload) {
    state.eventDetails = payload;
  },
  [types.BookingArtist.UPDATE.ALL](state, payload) {
    console.log(payload);
    state.bookingArtistList = BookingArtist.updateList(state.bookingArtistList, payload);
  },
  [types.SET_PERFORMANCE_TYPE](state, {
    calendarDateArtistId, PRIMARY_KEY,
    value
  }) {
    const artist = state
      .bookingOverview
      .artists.find(e =>
        e.calendar_date_artist_id === calendarDateArtistId);
    artist.performance_type = value;
    const artist2 = state
      .artists.data.find(e =>
        e.calendar_date_artist_id === calendarDateArtistId);
    artist2.performance_type = value;

    BookingArtist.findByPk(state.bookingArtistList, PRIMARY_KEY)['performance_type'] = value;
  },
  [types.SET_SOUNDCHECK](state, {
    calendarDateArtistId, PRIMARY_KEY,
    value
  }) {
    const artist = state
      .artists.data.find(e =>
        e.calendar_date_artist_id === calendarDateArtistId);

    artist.soundcheck = value;
  },
  [types.SET_STAGE_TIME](state, {
    calendarDateArtistId, PRIMARY_KEY,
    value
  }) {
    const artist = state
      .artists.data.find(e =>
        e.calendar_date_artist_id === calendarDateArtistId);

    artist.performance_time = value;
  },
  [types.SET_DURATION](state, {
    calendarDateArtistId, PRIMARY_KEY,
    value
  }) {
    const artist = state
      .artists.data.find(e =>
        e.calendar_date_artist_id === calendarDateArtistId);

    artist.performance_time_contract = value;
  },
  [types.SET_STAGE](state, {
    calendarDateArtistId, PRIMARY_KEY,
    value
  }) {
    const artist = state
      .artists.data.find(e =>
        e.calendar_date_artist_id === calendarDateArtistId);

    artist.stage_name = value;
  },
  [types.SET_CONFIRMED](state, {
    calendarDateArtistId, PRIMARY_KEY,
    value
  }) {
    const artist = state
      .artists.data.find(e =>
        e.calendar_date_artist_id === calendarDateArtistId);

    artist.confirmed_flag = value;
  },
  [types.SET_DOORS_OPEN](state, {
    value
  }) {
    state.eventDetails.data.cdate['doors_open'] = value;
  },
  [types.SET_CURFEW](state, {
    value
  }) {
    state.eventDetails.data.cdate['curfew'] = value;
  },
  [types.SET_EVENT_URL](state, {
    value
  }) {
    state.eventDetails.data.cdate['event_url'] = value;
  },
  [types.SET_LINE_UP](state, {
    value
  }) {
    state.eventDetails.data.cdate['lineup'] = value;
  },
  [types.SET_CUSTOM_DATA](state, {
    customDataId, value
  }) {
    // state.eventDetails.data.fields = 
    state
      .eventDetails.data.fields.map(e => {
        if (e.custom_data_id === customDataId) {
          e.data = value;
        }
        return e;
      })
  },


  // TRAVEL_DETAILS MUTATIONS
  [types.UPDATE_TRAVEL_DETAILS_STATE](state, payload) {
    state.travelDetailsState = {
      ...state.travelDetailsState,
      ...payload
    };
  },
  [types.TRAVEL.UPDATE.SINGLE](state, { item, newItem }) {
    const currentItem = state.travelDetailsState.data.travels.find(t => {
      if (t.travel_id === item.travel_id) {
        return true;
      } else {
        return false;
      }
    });

    updateMutatable(currentItem, newItem);
  },
  [types.TRAVEL.DELETE.SINGLE](state, travelId) {
    state.travelDetailsState.data.travels = state.travelDetailsState.data.travels.filter(e => e.travel_id !== travelId);
  },

  // LOCAL_DETAILS MUTATIONS

  [types.SET_LOCAL_DETAILS](state, localDetails) {
    state.calendar_date_locals = localDetails.data.calendar_date_locals;
    state.localInfo = localDetails.data.cdate.local_info;

    state.localDetails = localDetails.data;
  },
  [types.SET_LOCAL_INFO](state, value) {
    state.localInfo = value;
  },
  [types.SET_LOCAL_DETAILS_CONFIRMED_FLAG](state, value) {
    state.localDetails.cdate.local_details_confirmed_flag = value;
  },
  [types.DELETE_CALENDAR_DATE_LOCALS](state, localDetailsId) {
    console.log(localDetailsId);
    state.calendar_date_locals = state.calendar_date_locals.filter(e => {
      if (e.local_detail_id !== localDetailsId) {
        return true;
      } else {
        return false;
      }
    })
  },
  [types.PROMOTER_DEFAULT.SET.SINGLE](state, payload) {
    state.promoterDefault = payload;
  },
  [types.SET_RELATION_TYPES](state, payload) {
    state.relationTypes = payload.relation_types;
  },


  // DOCUMENTS_MUTATIONS
  [types.SET_MANY_DOCUMENTS](state, payload) {
    state.documents.data = payload;
  },
  [types.SET_MANY_DOCUMENTS_DATASTATE](state, payload) {
    state.documents.dataState = payload;
  },
  [types.SET_MANY_FILES](state, payload) {
    state.files.data = payload;
  },
  [types.SET_MANY_FILES_DATASTATE](state, payload) {
    state.files.dataState = payload;
  },

  [types.DOCUMENTDATA.UPDATE.ALL](state, payload) {
    state.documentsData = {
      ...state.documentsData,
      ...payload
    };
  },
  [types.DOCUMENTS.UPDATE.ALL](state, payload) {
    state.documents = {
      ...state.documents,
      ...payload
    };
  },
  [types.UPDATE_DOCUMENT_SIGNED_ID](state, {
    documentId,
    signedDocumentId
  }) {
    state.documents.data = state.documents.data.map(e => {
      if (e.document_id === documentId) {
        e.signed_documents_id = signedDocumentId
      }
      return e;
    })
  },

  [types.DOCUMENTS.DELETE.SINGLE](state, payload) {
    state.documents.data = state.documents.data.filter(doc => doc.document_id !== payload);
  },
  [types.FILES.UPDATE.ALL](state, payload) {
    state.files = {
      ...state.files,
      ...payload
    };
  },
  [types.TEMPLATES.UPDATE.ALL](state, payload) {
    state.templates = {
      ...state.files,
      ...payload
    };
  },

  [types.FILES.DELETE.SINGLE](state, { fileId, fileRelationId }) {
    // console.log(fileId, fileRelationId, state.files.data.filter(e => e.file_id != fileId && e.file_relation_id != fileRelationId))
    state.files.data = state.files.data.filter(e => e.file_id != fileId && e.file_relation_id != fileRelationId);
  },









  //TODO: CENTRALIZED STORE MUTATIONS ONGOING
  // ALL FOLLOWING ACTIONS ARE FOR NESTED BOOKING DETAILS STRUCTURE
  // PROCEED CONCURRENTLY WITH THE PREVIOUS ACTIONS - 
  // AND REDUCE THE TOP PART TO ZERO 






  // BOOKING DET
  ...implementSetAllNavTabDetailsMutation(types.BookingDetails, 'bookingDetails'),
  // [types.BookingDetails.SET.ALL](state, payload) {
  //   state.bookingDetails = payload;
  // },

  [types.SET_ARTIST_FIELD](state, {
    calendar_date_artist_id,
    calendar_date_id,
    name,
    value
  }) {
    state.bookingDetails[calendar_date_id].artists.find(a => a.calendar_date_artist_id == calendar_date_artist_id)[name] = value;
  },
  [types.SET_ARTIST](state, {
    calendar_date_artist_id,
    calendar_date_id,
    name,
    value
  }) {
    state.bookingDetails[calendar_date_id].artists.find(a => a.calendar_date_artist_id == calendar_date_artist_id)[name] = value;
  },
  [types.BDArtists.SET.SINGLE](state, {
    calendar_date_artist_id,
    calendar_date_id,
    update
  }) {
    state.bookingDetails[calendar_date_id].artists = state.bookingDetails[calendar_date_id].artists.map(a => {
      if (a.calendar_date_artist_id == calendar_date_artist_id) {
        return {
          ...a,
          ...update,
        }
      } else {
        return a;
      }
    })
  },

  // CALENDAR_BOOKING_LIST Mutations
  [types.CALENDAR_FILTER.SET.ALL](state, payload) {
    state.calendarFilter = {
      ...state.calendarFilter,
      ...payload,
    };
    // sessionStorage.setItem(types.CALENDAR_FILTER.NAME, JSON.stringify(state.calendarFilter));
  },
  [types.CALENDAR_BOOKING_LIST.SET.ALL](state, payload) {
    console.log("OOP", payload)
    state.calendarBookingList = payload;
  }
};